(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ukr-product-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ukr-product-carousel')) {
  const groupCache = new Map();
  const detailCache = new Map();
  const colourOrder = ['White', 'Anthracite', 'Raw Metal', 'Antique Brass', 'Brushed Brass', 'Black', 'Black Copper'];
  const query = `query CarouselColours($query: String!, $after: String, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
    products(first: 250, after: $after, query: $query, sortKey: ID) {
      pageInfo { hasNextPage endCursor }
      nodes { id title handle tags availableForSale }
    }
  }`;
  let activeRequests = 0;
  const waiting = [];
  async function request(url, options = {}) {
    if (activeRequests >= 4) await new Promise(resolve => waiting.push(resolve));
    else activeRequests++;
    try {
      for (let attempt = 0; attempt < 3; attempt++) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { ...options, signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`Carousel request failed (${response.status})`);
          const result = await response.json();
          if (result?.errors?.length) throw new Error('Carousel product lookup was rejected');
          return result;
        } catch (error) {
          if (attempt === 2) throw error;
        } finally { clearTimeout(timeout); }
        await new Promise(resolve => setTimeout(resolve, 400 * (attempt + 1)));
      }
    } finally {
      const next = waiting.shift();
      if (next) next();
      else activeRequests--;
    }
  }
  function colourOf(title) {
    const match = title.match(/\b(white|anthracite|raw metal|antique brass|brushed brass|black copper|black)\b/i);
    return match ? colourOrder.find(colour => colour.toLowerCase() === match[1].toLowerCase()) : null;
  }
  function configuration(title) {
    const text = title.toLowerCase().replace(/\s+/g, ' ').trim();
    const size = text.match(/h\s*(\d+)\s*mm\s*[x×]\s*w\s*(\d+)\s*mm/);
    if (!size) return null;
    return JSON.stringify([
      Number(size[1]), Number(size[2]),
      text.match(/\b(\d+)\s*column\b/)?.[1] || null,
      text.match(/\b(single|double|triple)\s*panel\b/)?.[1] || null,
      text.match(/\b(straight|curved)\b/)?.[1] || null,
      text.match(/\b(vertical|horizontal)\b/)?.[1] || null,
      text.match(/\b(\d+)\s*w(?:att)?s?\b/)?.[1] || null,
      text.includes('thermostatic wifi') ? 'thermostatic wifi' : text.includes('thermostatic') ? 'thermostatic' : text.includes('standard') ? 'standard' : null,
      /\b(feet included|with feet)\b/.test(text),
      /\belectric\b/.test(text), /\bdual fuel\b/.test(text)
    ]);
  }
  function sameConfiguration(a, b) {
    const left = configuration(a), right = configuration(b);
    if (left || right) return left !== null && left === right;
    const normalize = title => title.toLowerCase().replace(/\b(white|anthracite|raw metal|antique brass|brushed brass|black copper|black)\b/i, '').replace(/\s+/g, ' ').trim();
    return normalize(a) === normalize(b);
  }
  function productURL(root, handle) {
    return `${root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}`;
  }
  function getGroup(group, token, country, language) {
    const cacheKey = JSON.stringify([group, token, country, language]);
    if (groupCache.has(cacheKey)) return groupCache.get(cacheKey);
    const pending = (async () => {
      const products = new Map(), cursors = new Set();
      let after = null;
      const tagQuery = `tag:'${group.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`;
      do {
        const result = await request('/api/2026-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query, variables: { query: tagQuery, after, country, language } })
        });
        const connection = result?.data?.products;
        if (!connection || !Array.isArray(connection.nodes)) throw new Error('Missing colour results');
        for (const product of connection.nodes) {
          if (product.tags?.includes(group)) products.set(product.id, product);
        }
        if (!connection.pageInfo.hasNextPage) break;
        after = connection.pageInfo.endCursor;
        if (!after || cursors.has(after)) throw new Error('Invalid colour pagination');
        cursors.add(after);
      } while (true);
      return [...products.values()];
    })().catch(error => { groupCache.delete(cacheKey); throw error; });
    groupCache.set(cacheKey, pending);
    return pending;
  }
  function getDetails(url, key) {
    if (detailCache.has(key)) return detailCache.get(key);
    const endpoint = new URL(url, location.origin);
    endpoint.searchParams.set('view', 'ukr-carousel-data');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) endpoint.searchParams.set('preview_theme_id', preview);
    const pending = request(endpoint.toString()).then(data => {
      if (!data || !data.id || typeof data.price !== 'string' || typeof data.url !== 'string') throw new Error('Invalid carousel product data');
      return data;
    }).catch(error => { detailCache.delete(key); throw error; });
    detailCache.set(key, pending);
    return pending;
  }

  customElements.define('ukr-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ukrc-track');
      this.previous = this.querySelector('.ukrc-prev');
      this.next = this.querySelector('.ukrc-next');
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.previous.hidden = this.next.hidden = false;
      this.querySelector('.ukrc-dots').hidden = false;
      this.positions = [];
      this.addEventListener('click', event => {
        const swatch = event.target.closest('.ukrc-swatch');
        if (swatch && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          this.chooseColour(swatch);
          return;
        }
        const retry = event.target.closest('[data-retry-colours]');
        if (retry) { this.loadCardColours(retry.closest('.ukrc-card')); return; }
        const step = event.target.closest('[data-step]');
        const dot = event.target.closest('[data-slide]');
        if (!step && !dot) return;
        const current = this.closestPosition();
        const index = dot ? Number(dot.dataset.slide) : current + Number(step.dataset.step);
        const target = this.positions[Math.max(0, Math.min(index, this.positions.length - 1))];
        this.track.scrollTo({ left: target || 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { ...options, passive: true });
      let drag = null;
      let suppressClickUntil = 0;

      this.track.addEventListener('dragstart', event => {
        event.preventDefault();
      }, options);

      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        suppressClickUntil = 0;
        if (event.target.closest('button, .ukrc-swatch, input, select, textarea')) return;

        drag = {
          id: event.pointerId,
          x: event.clientX,
          scroll: this.track.scrollLeft,
          moved: false
        };
      }, options);

      window.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;

        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;

        drag.moved = true;
        event.preventDefault();
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = drag.scroll - distance;
      }, { ...options, passive: false });

      const finishDrag = event => {
        if (!drag) return;
        if (event.pointerId !== undefined && event.pointerId !== drag.id) return;

        if (drag.moved) suppressClickUntil = performance.now() + 250;

        drag = null;
        this.track.classList.remove('is-dragging');
      };

      window.addEventListener('pointerup', finishDrag, options);
      window.addEventListener('pointercancel', finishDrag, options);
      window.addEventListener('blur', finishDrag, options);

      this.controller.signal.addEventListener('abort', () => {
        drag = null;
        this.track.classList.remove('is-dragging');
      }, { once: true });

      this.track.addEventListener('click', event => {
        if (event.detail === 0 || performance.now() >= suppressClickUntil) return;

        suppressClickUntil = 0;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.track);
      this.measure();
      this.life = {};
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.intersection.disconnect();
            this.loadColours();
          }
        }, { rootMargin: '350px' });
        this.intersection.observe(this);
      } else this.loadColours();
    }
    disconnectedCallback() {
      this.life = null;
      this.intersection?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    measure() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.track.firstElementChild;
      this.positions = [];
      if (first) {
        const origin = first.getBoundingClientRect().left;
        for (const slide of this.track.children) {
          const position = Math.min(max, Math.max(0, slide.getBoundingClientRect().left - origin));
          if (!this.positions.length || Math.abs(position - this.positions.at(-1)) > 2) this.positions.push(position);
        }
      }
      this.dots.forEach((dot, index) => { dot.hidden = index >= this.positions.length || max <= 2; });
      this.update();
    }
    closestPosition() {
      return this.positions.reduce((best, position, index) => Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[best] - this.track.scrollLeft) ? index : best, 0);
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const active = this.closestPosition();
      this.dots.forEach((dot, index) => {
        if (index === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    detailKey(handle) {
      return JSON.stringify([this.dataset.root, this.dataset.country, this.dataset.language, handle]);
    }
    loadColours() {
      for (const card of this.querySelectorAll('.ukrc-card')) this.loadCardColours(card);
    }
    async loadCardColours(card) {
      if (card.dataset.coloursReady === 'true' || card.coloursLife === this.life) return;
      const life = this.life;
      card.coloursLife = life;
      const status = card.querySelector('.ukrc-colour-status');
      try {
        const initial = JSON.parse(card.dataset.initial);
        detailCache.set(this.detailKey(card.dataset.handle), Promise.resolve(initial));
        if (!card.dataset.group || !colourOf(card.dataset.title)) {
          card.dataset.coloursReady = 'true';
          return;
        }
        if (!this.dataset.token) throw new Error('Public Storefront token is missing');
        const products = await getGroup(card.dataset.group, this.dataset.token, this.dataset.country, this.dataset.language);
        if (this.life !== life || !this.contains(card)) return;
        const choices = new Map();
        choices.set(colourOf(card.dataset.title), { title: card.dataset.title, handle: card.dataset.handle });
        for (const candidate of products) {
          const colour = colourOf(candidate.title);
          if (colour && !choices.has(colour) && candidate.availableForSale && sameConfiguration(candidate.title, card.dataset.title)) choices.set(colour, candidate);
        }
        const fragment = document.createDocumentFragment();
        if (choices.size > 1) {
          for (const colour of colourOrder) {
            const candidate = choices.get(colour);
            if (!candidate) continue;
            const link = document.createElement('a');
            link.className = `ukrc-swatch ukrc-${colour.toLowerCase().replaceAll(' ', '-')}`;
            link.href = productURL(this.dataset.root, candidate.handle);
            link.dataset.handle = candidate.handle;
            link.dataset.colour = colour;
            link.title = colour;
            link.setAttribute('aria-label', colour);
            if (candidate.handle === card.dataset.handle) link.setAttribute('aria-current', 'true');
            fragment.append(link);
          }
        }
        card.querySelector('.ukrc-swatches').replaceChildren(fragment);
        status.hidden = true;
        status.replaceChildren();
        card.dataset.coloursReady = 'true';
      } catch (error) {
        if (this.life !== life || !this.contains(card)) return;
        status.textContent = `${this.dataset.failed} `;
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.dataset.retryColours = '';
        retry.textContent = this.dataset.retry;
        status.append(retry);
        status.hidden = false;
        console.warn('UKR carousel: colour lookup failed.', error.message);
      } finally {
        if (card.coloursLife === life) card.coloursLife = null;
      }
    }
    async chooseColour(swatch) {
      const card = swatch.closest('.ukrc-card');
      const selection = {};
      const life = this.life;
      card.selection = selection;
      card.setAttribute('aria-busy', 'true');
      const status = card.querySelector('.ukrc-colour-status');
      status.hidden = true;
      this.querySelector('[role="status"]').textContent = this.dataset.loading;
      try {
        const data = await getDetails(swatch.href, this.detailKey(swatch.dataset.handle));
        if (card.selection !== selection || this.life !== life || !this.contains(card)) return;
        this.select(swatch, data);
      } catch (error) {
        if (card.selection !== selection || this.life !== life || !this.contains(card)) return;
        status.textContent = this.dataset.failed;
        status.hidden = false;
        this.querySelector('[role="status"]').textContent = this.dataset.failed;
        console.warn('UKR carousel: product update failed.', error.message);
      } finally {
        if (card.selection === selection) card.removeAttribute('aria-busy');
      }
    }

    select(swatch, data) {
      const card = swatch.closest('.ukrc-card');
      card.dataset.productId = String(data.id);
      card.querySelectorAll('[data-link]').forEach(link => { link.href = data.url; });
      for (const key of ['brand', 'name', 'details', 'price', 'compare', 'saving', 'badge']) {
        const node = card.querySelector(`[data-field="${key}"]`);
        node.textContent = data[key] || '';
        node.hidden = !data[key];
      }
      const photo = card.querySelector('.ukrc-photo');
      photo.hidden = !data.image;
      photo.alt = data.alt;
      if (data.image) {
        photo.width = data.width;
        photo.height = data.height;
        photo.sizes = '(min-width: 1440px) 300px, (min-width: 1280px) 23vw, (min-width: 1024px) 29vw, (min-width: 768px) 36vw, 56vw';
        photo.srcset = data.srcset;
        photo.src = data.image;
      } else {
        photo.removeAttribute('srcset');
        photo.removeAttribute('src');
      }
      card.querySelectorAll('.ukrc-swatch').forEach(link => {
        if (link === swatch) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      this.querySelector('[role="status"]').textContent = `${data.title}. ${data.price}`;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
